<div class="flex flex-col gap-2 p-4">
  <strong>Incident breakdown</strong>
  <div class="flex items-center gap-2">
    <avs-incident-severity-icon [severity]="eIncidentSeverity.CRITICAL" />
    <span class="text-sm font-medium">
      {{ critical() }}
    </span>
  </div>
  <div class="flex items-center gap-2">
    <avs-incident-severity-icon [severity]="eIncidentSeverity.MAJOR" />
    <span class="text-sm font-medium">
      {{ major() }}
    </span>
  </div>
  <div class="flex items-center gap-2">
    <avs-incident-severity-icon [severity]="eIncidentSeverity.MINOR" />
    <span class="text-sm font-medium">
      {{ minor() }}
    </span>
  </div>
</div>
